import * as req from 'api/actions';
import * as c from './constant';

export const dummy = () => {};

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    '/api/v1/administrators/settings/csv_imports',
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );